import { variables } from '@resurs/midas'

export default {
  historyContainer: {
    maxHeight: '200px',
    overflowY: 'auto',
    overflowX: 'hidden',
    marginTop: '0',
  },
  bubble: {
    margin: '-.5rem',
    marginLeft: '0',
    marginRight: '0',
    fontSize: '1.1rem',
    padding: '.8rem',
    background: '#eee',
  },
  title: {
    fontSize: '4rem',
    color: variables.coreColor,
  },
  message: {
    whiteSpace: 'pre-line',
  },
  timeStamp: {
    float: 'right',
    fontSize: '1rem',
  },
  queuePos: {
    fontSize: '8rem',
    color: variables.coreColor,
  },
}
